// extracted by mini-css-extract-plugin
export default {"container":"g3-z"};